import { UseQueryResult } from '@tanstack/react-query';
import { getFragmentMediaUrl } from '../utils/fragment-media-url';
import { useFragmentQuery } from './useFragment';

/**
 * Exposes the fragment's signed media URL (from `fragment.assets`) in the shape of a query result,
 * so it can be composed with `QueriesView` (from `@mi-front/ui`) alongside `useFragmentQuery`.
 * Stays in a loading state until the fragment is loaded and a media URL is present (e.g. while assets are still processing).
 */
export function useFragmentMediaUrlQuery(fragmentId: string): UseQueryResult<string> {
  const fragmentQuery = useFragmentQuery(fragmentId);
  const url = fragmentQuery.data ? getFragmentMediaUrl(fragmentQuery.data) : undefined;
  const waitingForAssetUrl =
    fragmentQuery.isSuccess && url === undefined && !fragmentQuery.isError;

  return {
    data: url,
    error: fragmentQuery.error,
    isError: fragmentQuery.isError,
    isLoading: fragmentQuery.isLoading || waitingForAssetUrl,
  } as UseQueryResult<string>;
}
